var slider = new KeenSlider("#featured-companies__quotes--slider", {
  loop: true,
},
[navigation],
[
  (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout);
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next();
      }, 10000)
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  },
]);
var thumbnails = new KeenSlider(
  "#featured-company__thumbnails--slider",
  {
    initial: 0,
    spacing: 10,
    breakpoints: {
      '(max-width: 449px)': {
        slides: {
          perView: 2.5
        }
      },
      '(min-width: 450px)': {
        slides: {
          perView: 3.5
        }
      },
      '(min-width: 750px)': {
        slides: {
          perView: 5
        }
      },
    },
  },
  [ThumbnailPlugin(this.slider)]
)

// Prevent layout shifting
document.querySelectorAll('.featured-company__thumbnails .keen-slider__slide').forEach(el => el.style.display = 'block');